export const Sigil = ({ className = "" }) => (
  <svg viewBox="0 0 400 400" className={className} aria-hidden="true">
    <g fill="none" stroke="currentColor">
      <circle cx="200" cy="200" r="190" strokeWidth="1" />
      <circle cx="200" cy="200" r="172" strokeWidth="0.6" strokeDasharray="2 6" />
      <circle cx="200" cy="200" r="130" strokeWidth="0.8" />
      <polygon points="200,30 347,285 53,285" strokeWidth="0.8" />
      <polygon points="200,370 53,115 347,115" strokeWidth="0.8" />
      {Array.from({ length: 24 }).map((_, i) => {
        const a = (i / 24) * Math.PI * 2;
        return <line key={i} x1={200 + Math.cos(a) * 172} y1={200 + Math.sin(a) * 172} x2={200 + Math.cos(a) * 190} y2={200 + Math.sin(a) * 190} strokeWidth="1" />;
      })}
    </g>
  </svg>
);
